export const ORDERS = {
  ASC: 'asc',
  DESC: 'desc',
};
